import { Typography } from "@mui/material";

import type { Asset } from "./server/digital-asset-service";
import type { Folder } from "./server/folder-service";
import type { FC } from "react";

export const AssetCount: FC<{ assets: Asset[]; folders: Folder[]; searchText?: string }> = ({
  assets,
  folders,
  searchText,
}) => (
  <Typography variant="h6">
    {folders.length > 0 ? (
      <>
        {folders.length} folder{folders.length === 1 ? "" : "s"}
        {", "}
      </>
    ) : (
      ""
    )}
    {assets.length} asset{assets.length === 1 ? "" : "s"}
    {searchText ? ` found for "${searchText}"` : ""}
  </Typography>
);
